import React, { Component } from "react";

import JoinCard from "./JoinCard";
import JobCardHeader from "./JobCardHeader";

import { Button, Card, CardContent, Divider, Typography } from "material-ui";

import Logo from "../img/logo.png";

import {Title} from '../helper/consts'

export default class LoggedOutCard extends Component {
  constructor() {
    super();

    this.state = {
      loggingIn: false
    };
  }

  handleClick = () => {
    this.setState({
      loggingIn: !this.state.loggingIn
    });
  };

  render() {
    const job = {
      logo: {
        downloadURLs: [Logo]
      },
      company: this.props.title ? this.props.title : "Login to continue.",
      location: `You must be logged in to apply or share.`,
      title: ""
    };
    return (
      <Card key="loggedOut" className="card">
        <JobCardHeader job={job} />
        <Divider light />
        {this.state.loggingIn ? (
          <JoinCard hideHeader={false} />
        ) : (
          <CardContent>
            <Typography align="left" color="inherit" type="body1">
              {this.props.message
                ? this.props.message
                : `Please Login to ${Title} continue.`}
            </Typography>
          </CardContent>
        )}
        <CardContent>
          <Button raised onClick={this.handleClick}>
            {this.state.loggingIn ? "Cancel" : "Login"}
          </Button>
        </CardContent>
      </Card>
    );
  }
}
// <LoginBtn />



// WEBPACK FOOTER //
// ./src/components/LoggedOutCard.js